// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 300;
  right: 0;
  margin: 0.5em;
  z-index: 1200;
}

a:hover {
  text-decoration: underline;
  font-weight: bolder;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/core/app-toast/app-toast.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/core/app-toast/app-toast.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;ACCF;;ADEA;EACE,0BAAA;EACA,mBAAA;EACA,eAAA;ACCF","sourcesContent":[":host {\r\n  position: fixed;\r\n  top: 300;\r\n  right: 0;\r\n  margin: 0.5em;\r\n  z-index: 1200;\r\n}\r\n\r\na:hover {\r\n  text-decoration: underline;\r\n  font-weight: bolder;\r\n  cursor: pointer;\r\n}\r\n",":host {\n  position: fixed;\n  top: 300;\n  right: 0;\n  margin: 0.5em;\n  z-index: 1200;\n}\n\na:hover {\n  text-decoration: underline;\n  font-weight: bolder;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
